import { VFC, useEffect, useState, useCallback } from 'react';
import {
  Center,Text,Button,Select,Checkbox,Input,
  Table,Tbody,Tr,Th,Td,Flex} from '@chakra-ui/react';
import { RepeatIcon } from '@chakra-ui/icons';
import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import { PeriodInput } from './PeriodInput';
import { getStringFromDate } from '../../../hooks/useDateUtils';
import { searchParam } from '../../../types/issue';
import { BuObj } from '../../../types/user';

type Props = {
  func: string;
  searchParam: searchParam;
  setSearchParam: (param:searchParam)=>void;
  defaultSearchDays: number;
  maxSearchDays: number;
  cloud_list: string[];
  executing: boolean;
  execSearch: ()=>void;
};

export const SearchInput: VFC<Props> = (props) => {
  const { func, searchParam, setSearchParam, defaultSearchDays, maxSearchDays, cloud_list, executing, execSearch } = props;
  const { loginUser } = useLoginUser();
  const [ fromDate, setFromDate ] = useState<Date|null>(null);
  const [ toDate, setToDate ] = useState<Date|null>(null);
  const [ custName, setCustName ] = useState<string>(sessionStorage.getItem('custName') ?? '');
  const [ blankFlag, setBlankFlag ] = useState<boolean>(false);
  const [ buName, setBuName ] = useState<string>(sessionStorage.getItem('buName') ?? '');
  const [ cloud_type, setCloud_type ] = useState<string>(sessionStorage.getItem('cloud_type') ?? '');
  const [ noticeKind, setNoticeKind ] = useState<string>('');
  const [ periodName ] = useState<string>(func === 'case' ? '更新日時' : func === 'notice' ? '通知日' : '障害発生日');
  const [ dateErrFlag, setDateErrFlag ] = useState(false);
  const appType = process.env.REACT_APP_APP_TYPE;
  
  // 入力値のセット
  useEffect(() => {
    const tmpParam:searchParam = {...searchParam};
    tmpParam.username = loginUser.username;
    tmpParam.userGroup = loginUser.userGroup;
    tmpParam.fromDate = getStringFromDate(fromDate);
    tmpParam.toDate = getStringFromDate(toDate);
    tmpParam.buName = buName;
    tmpParam.custName = custName;
    tmpParam.blankFlag = blankFlag;
    tmpParam.cloud_type = (func === 'notice' && (cloud_type === '' || cloud_type === 'GCP')) ? 'AWS' : cloud_type;
    tmpParam.noticeKind = noticeKind;
    setSearchParam(tmpParam);
    
    // 画面間パラメータ引継ぎ
    sessionStorage.setItem('cloud_type',cloud_type);
    sessionStorage.setItem('buName',buName);
    sessionStorage.setItem('custName',custName);
    
// console.log(tmpParam);
    
  }, [fromDate,toDate,custName,blankFlag,cloud_type,noticeKind,buName]);
  
  // 空白チェック
  const checkBlank = useCallback((flag:boolean) => {
    setBlankFlag(flag);
    if( flag ) setCustName('');
    
  }, []);
  
  return (
    <Center>
      <Flex alignItems="end" gap="10px">
        {(!loginUser.necFlag && func === 'current') ? (
          <></>
        ) : (
          <>
          <Table size='xs' maxW="720px" border="0px">
            <Tbody>
              {appType === 'ADMIN' && (
                <Tr>
                  <Th><Text fontSize="sm">対象ＢＵ</Text></Th>
                  <Td>
                    <Select maxW="200px" onChange={(e)=>setBuName(e.target.value)} value={buName} size='xs' color="black">
                    {loginUser.bu_list && loginUser.bu_list.map((item:BuObj)=>(
                      <option key={item.bu_name} value={item.bu_name}>{item.bu_name}</option>
                    ))}
                    </Select>
                  </Td>
                </Tr>
              )}
              {(loginUser.necFlag && (
                'current,history'.includes(func) ||
                (func === 'notice' && appType === 'ADMIN'))) && (
                <Tr>
                  <Th><Text fontSize="sm">クラウド種別</Text></Th>
                  <Td>
                    <Select maxW="200px" onChange={(e)=>setCloud_type(e.target.value)} value={cloud_type} size='xs' color="black">
                    {cloud_list.map((item:string)=>(
                      <option key={item} value={item}>{item}</option>
                    ))}
                    </Select>
                  </Td>
                </Tr>
              )}
              {func === 'notice' && (
                <Tr>
                  <Th><Text fontSize="sm">メール分類</Text></Th>
                  <Td>
                    <Select maxW="200px" onChange={(e)=>setNoticeKind(e.target.value)} value={noticeKind} size='xs' color="black">
                    {loginUser.mailgroup_class_list.map((item:string)=>(
                      <option key={item} value={item}>{item}</option>
                    ))}
                    </Select>
                  </Td>
                </Tr>
              )}
              {(loginUser.necFlag && func !== 'current') && (
                <Tr>
                  <Th><Text fontSize="sm">お客様名</Text></Th>
                  <Td>
                    <Flex>
                    <Input width="200px" size="xs" id="mailcustomer" onChange={(e)=>setCustName(e.target.value)} value={custName} disabled={blankFlag} />
                    <Checkbox id='mail-check-empty' paddingLeft="5px" onChange={(e)=>checkBlank(e.target.checked)} isChecked={blankFlag}>
                      <Text fontSize="xs" as="b">空白のもののみ検索</Text>
                    </Checkbox>
                    </Flex>
                  </Td>
                </Tr>
              )}
              {func !== 'current' && (
                <Tr>
                  <Th><Text fontSize="sm">{`${periodName}（最大${maxSearchDays}日間）`}</Text></Th>
                  <Td>
                    <PeriodInput
                      toDate={toDate}
                      fromDate={fromDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      setDateErrFlag={setDateErrFlag}
                      defaultSearchDays={defaultSearchDays}
                      maxSearchDays={maxSearchDays}
                    />
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          <Button
            id="history-button-search"
            rightIcon={<RepeatIcon />}
            autoFocus={true}
            isLoading={executing}
            isDisabled={dateErrFlag}
            onClick={execSearch}
          >
            検索
          </Button>
          </>
        )}
      </Flex>
    </Center>
  );
};
